import { Icon20InfoCircleOutline } from '@vkontakte/icons';
import React, { type ReactNode, memo, useEffect } from 'react';
import { Button, ButtonSizeMode } from 'reactApp/ui/Button/Button';

import styles from './InformationAlertBanner.css';

interface InformationAlertProps {
    title: string | ReactNode;
    content: string | ReactNode;
    primaryButtonTitle?: string;
    secondaryButtonTitle?: string | false;

    onShow?(): void;

    onPrimaryClick?(): void;

    onSecondaryClick?(): void;
}

export const InformationAlertBanner = memo<InformationAlertProps>(
    ({ title, content, primaryButtonTitle, secondaryButtonTitle, onShow, onPrimaryClick, onSecondaryClick }) => {
        useEffect(() => {
            onShow?.();
        }, [onShow]);

        return (
            <div className={styles.root} data-qa-id="information-alert-banner">
                <Icon20InfoCircleOutline className={styles.icon} />
                <div className={styles.content}>
                    <div className={styles.title} data-qa-id="title">
                        {title}
                    </div>
                    <div className={styles.text} data-qa-id="content">
                        {content}
                    </div>
                </div>
                <div className={styles.buttons}>
                    {primaryButtonTitle && (
                        <Button
                            className={styles.button}
                            data-name="primary-bttn"
                            data-qa-id="primary-bttn"
                            theme="octavius"
                            sizeMode={ButtonSizeMode.small}
                            onClick={onPrimaryClick}
                            error
                        >
                            {primaryButtonTitle}
                        </Button>
                    )}
                    {secondaryButtonTitle && (
                        <Button
                            className={styles.button}
                            onClick={onSecondaryClick}
                            theme="octavius"
                            sizeMode={ButtonSizeMode.small}
                            data-name="secondary-bttn"
                            data-qa-id="secondary-bttn"
                        >
                            {secondaryButtonTitle}
                        </Button>
                    )}
                </div>
            </div>
        );
    }
);

InformationAlertBanner.displayName = 'InformationAlertBanner';
